var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78378 0.5C3.9164 0.5 4.03714 0.571775 4.10125 0.685022L4.12255 0.729375L5.09553 3.16199C5.15538 3.31165 5.10953 3.4805 4.98782 3.57994L4.94448 3.6104L4.02605 4.16108L4.03129 4.17039C4.43628 4.86566 5.00319 5.45197 5.68259 5.87987L5.8387 5.97387L6.38983 5.05586C6.47276 4.91764 6.63492 4.85198 6.78774 4.88872L6.83821 4.9048L9.27064 5.87785C9.39377 5.92711 9.47923 6.03859 9.49669 6.16755L9.5 6.21664V8.16273C9.5 8.90166 8.90103 9.50067 8.14003 9.5C4.02886 9.25014 0.75051 5.97155 0.5 1.83794C0.5 1.12638 1.05542 0.544563 1.75634 0.502442L1.83784 0.5H3.78378ZM3.53708 1.22949H1.83827C1.50242 1.22949 1.23016 1.50177 1.22949 1.81551C1.45696 5.5588 4.44172 8.54379 8.1626 8.7706C8.47746 8.7706 8.73642 8.53129 8.76757 8.22462L8.77071 8.16244V6.4635L6.85589 5.69723L6.28628 6.64735C6.19746 6.79538 6.01893 6.85899 5.85925 6.80622L5.81202 6.78687C4.68357 6.2303 3.77027 5.31693 3.21374 4.1884C3.13739 4.03356 3.18059 3.84902 3.31141 3.74334L3.35325 3.71411L4.30281 3.14396L3.53708 1.22949Z",
    fill: "#5D6F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7e7b82afc715de708fc5d99f6ab1f130.svg";
export { ForwardRef as ReactComponent };